import { ref } from "vue";

const addQuoteBottomSheetOpen = ref(false);
const editQuoteBottomSheetOpen = ref(false);
const selectedQuoteData = ref<any>(null);

export function useQuoteManagement() {
  function openAddQuoteBottomSheet() {
    addQuoteBottomSheetOpen.value = true;
  }

  function closeAddQuoteBottomSheet() {
    addQuoteBottomSheetOpen.value = false;
  }

  function openEditQuoteBottomSheet(quoteData: any) {
    selectedQuoteData.value = quoteData;
    // Use requestAnimationFrame to ensure the transition triggers properly
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        editQuoteBottomSheetOpen.value = true;
      });
    });
  }

  function closeEditQuoteBottomSheet() {
    editQuoteBottomSheetOpen.value = false;
    setTimeout(() => {
      selectedQuoteData.value = null;
    }, 300);
  }

  return {
    addQuoteBottomSheetOpen,
    editQuoteBottomSheetOpen,
    selectedQuoteData,
    openAddQuoteBottomSheet,
    closeAddQuoteBottomSheet,
    openEditQuoteBottomSheet,
    closeEditQuoteBottomSheet,
  };
}
